import { EmploymentPeriodDTO, PersonToOrganisationDTO } from 'api/core/models';
import { CheckPermissionFunction } from 'Auth/components/PermissionGate';
import { Actions, MultiInputControls } from 'pages/components/form/MultiInput/MultiInputControls';
import React, { ReactNode } from 'react';
import { EmploymentPeriods } from './EmploymentPeriods';
import { getDefaultPersonOrganisation } from '../../../../Settings/emptyModels';
import { ValidationResult } from '../../../../util/validation/interfaces';
import { JustifiedDeleteButton } from '../../../components/form/MultiInput/Buttons';
import { Panel } from '../layout/Panel';
import { Fieldset } from '../layout/Fieldset';
import { LabelledOrganisationSuggester } from '../../../components/form/LabelledOrganisationSuggester';
import {
  referencedOrganisationToSelectedOrganisation,
  SelectedOrganisation,
  selectedOrganisationToReferencedOrganisation,
} from '../suggester/OrganisationSuggester';

interface Props {
  title: string;
  checkPermission: CheckPermissionFunction;
  personOrganisations: PersonToOrganisationDTO[];
  onChange: (po: PersonToOrganisationDTO[]) => void;
  validation?: ValidationResult;
  autoFocus: boolean;
}

export const PersonOrganisations = (props: Props): ReactNode => {
  return (
    <Panel title={props.title} toggleable={true}>
      <MultiInputControls<PersonToOrganisationDTO>
        canEdit={props.checkPermission().canWrite}
        addNew={(rows: PersonToOrganisationDTO[]): number => rows.push(getDefaultPersonOrganisation())}
        lines={props.personOrganisations}
        onChange={props.onChange}
        renderLines={(personOrganisation: PersonToOrganisationDTO, onLineChange: (po: PersonToOrganisationDTO) => void, actions: Actions, idx: number) => (
          <Fieldset pt={{root: {className: 'surface-50'}}}>
            {props.checkPermission('organisation').canRead && (
              <LabelledOrganisationSuggester
                value={(personOrganisation.organisation ? [personOrganisation.organisation] : []).map(referencedOrganisationToSelectedOrganisation)}
                autoFocus={props.autoFocus}
                id={`personOrganisation${idx}`}
                permissions={props.checkPermission('organisation')}
                multiple={false}
                validation={props.validation?.children[idx]?.fields?.organisation}
                onChange={(ref: SelectedOrganisation[]): void => onLineChange({
                  ...personOrganisation,
                  organisation: ref.length > 0 ? ref.map(selectedOrganisationToReferencedOrganisation).pop() : undefined,
                })}
                label={`${props.title}.attr.organisation`}
              />
            )}
            <EmploymentPeriods
              autoFocus={props.autoFocus}
              title={`${props.title}.attr.employmentPeriods`}
              validation={props.validation?.children[idx]?.fields?.employment_periods}
              checkPermission={props.checkPermission}
              employmentPeriods={personOrganisation.employmentPeriods}
              onChange={(employmentPeriods: EmploymentPeriodDTO[]) => {
                onLineChange({...personOrganisation, employmentPeriods});
              }}
            />
            <JustifiedDeleteButton onClick={actions.delete} disabled={!props.checkPermission().canWrite}/>
          </Fieldset>
        )}
      />
    </Panel>
  );
};
